enum PmContractStatus {
  Semnat_Neinceput = 'Semnat Neinceput',
  Executie = 'Executie',
  Finalizat_Fara_PVRTL = 'Finalizat_Fara_PVRTL',
  Finalizat_PVRTL_semnat = 'Finalizat_PVRTL_semnat',
  Facturat = 'Facturat',
  Incasat = 'Incasat',
  Aprobat = 'Aprobat',
  Expirat_Arhivat = 'Expirat/Arhivat',
}

export default PmContractStatus;
